import { size as sizeTokens } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { css } from "styled-components";
import iconSizeMixin from "./iconSize";
import { textColorMixin, textColorMixinPropsType, } from "./textColor";
export const iconMixinPropsType = textColorMixinPropsType.complete({
    _size: true,
});
export const calculateIconSize = (v) => {
    let iconSize = 1;
    if (typeof v === "number") {
        iconSize = v;
    }
    if (typeof v === "string") {
        iconSize = parseInt(sizeTokens.icon[v]);
    }
    return iconSize;
};
export const iconMixin = css `
  ${iconSizeMixin};
  ${textColorMixin};

  & path,
  & rect,
  & polygon {
    color: inherit;
    ${(props) => !props.preventFill &&
    css `
        fill: currentColor;
      `}
  }
`;
export default iconMixin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taXhpbnMvaWNvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsSUFBSSxJQUFJLFVBQVUsRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQ3BGLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUV4QyxPQUFPLGFBQXFDLE1BQU0sWUFBWSxDQUFDO0FBQy9ELE9BQU8sRUFDTCxjQUFjLEVBRWQsdUJBQXVCLEdBQ3hCLE1BQU0sYUFBYSxDQUFDO0FBV3JCLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUM3Qix1QkFBdUIsQ0FBQyxRQUFRLENBQXFCO0lBQ25ELEtBQUssRUFBRSxJQUFJO0NBQ1osQ0FBQyxDQUFDO0FBRUwsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsQ0FBQyxDQUFXLEVBQVUsRUFBRTtJQUN2RCxJQUFJLFFBQVEsR0FBRyxDQUFDLENBQUM7SUFFakIsSUFBSSxPQUFPLENBQUMsS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUMxQixRQUFRLEdBQUcsQ0FBQyxDQUFDO0lBQ2YsQ0FBQztJQUNELElBQUksT0FBTyxDQUFDLEtBQUssUUFBUSxFQUFFLENBQUM7UUFDMUIsUUFBUSxHQUFHLFFBQVEsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUVELE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBRyxHQUFHLENBQWdCO0lBQ3hDLGFBQWE7SUFDYixjQUFjOzs7Ozs7TUFNWixDQUFDLEtBQUssRUFBRSxFQUFFLENBQ1YsQ0FBQyxLQUFLLENBQUMsV0FBVztJQUNsQixHQUFHLENBQUE7O09BRUY7O0NBRU4sQ0FBQztBQUVGLGVBQWUsU0FBUyxDQUFDIn0=